import { useIsLoggedInWithLoading } from '@dreamstack/auth'
import { HomeOwnershipOrderReportForm } from '@dreamstack/feature-components/src/homeOwnershipReport/HomeOwnershipOrderReportForm'
import { GridWithGaps } from '@dreamstack/feature-components/src/layout/MainGrid'
import { useTranslation } from '@dreamstack/i18n'
import { generateIdForText } from '@dreamstack/util'
import Skeleton from '@mui/material/Skeleton'
import type { FunctionComponent } from 'react'
import {
  FormContainer,
  StyledBodyText,
  StyledHeadingH2,
  TextContainer,
} from './CommonStyledComponents/AccessFileStyledComponents'

export const HomeOwnershipReportOrderForm: FunctionComponent<
  React.PropsWithChildren<{}>
> = () => {
  const t = useTranslation()
  const { loading, isLoggedIn } = useIsLoggedInWithLoading()
  const headingValue = t('accentro:homeOwnershipReportForm.heading')
  const headingId = generateIdForText(headingValue)
  return (
    <GridWithGaps>
      <StyledHeadingH2 id={headingId}>
        {t('accentro:homeOwnershipReportForm.heading')}
      </StyledHeadingH2>
      <TextContainer>
        <StyledBodyText className="whitespace-pre-line">
          {t('accentro:homeOwnershipReportForm.bodyText')}
        </StyledBodyText>
      </TextContainer>
      <FormContainer>
        {loading ? (
          <div className="flex flex-col justify-start">
            {Array.from({ length: 3 }).map((_, i) => (
              <Skeleton key={i} className="w-full" height={96} />
            ))}
          </div>
        ) : (
          <HomeOwnershipOrderReportForm />
        )}
      </FormContainer>
    </GridWithGaps>
  )
}
